import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PreviewIcon(props: IconProps) {
    return <Icon {...props} iconKey={"preview"}/>
}
